<template>
  <p class="text mt-2"><span v-html="text"></span></p>
</template>

<script>
export default {
  name: 'sectionText',
  props: ['text']
}
</script>

<style scoped>

.text {
  font-weight: 300;
}

</style>



// WEBPACK FOOTER //
// src/components/text/SectionText.vue